module.exports = __webpack_public_path__ + "static/media/img13.2dca666d.JPG";